import { useParticipantIds } from '@daily-co/daily-react'

export function useRemoteSessionId(): { remoteSessionId: string | undefined } {
  const remoteSessionId = useParticipantIds({ filter: 'remote' })?.[0]
  return { remoteSessionId }
}
